import { LOADER_START, LOADER_STOP } from './constant';

/**
 * Ref-count concurrent callLoader(1)/callLoader(0) pairs.
 * Existing pages keep the same API; the overlay stays visible until
 * the last in-flight load finishes (avoids flicker when APIs overlap).
 */
let pendingLoads = 0;

export const loaderStart = () => dispatch => {
    pendingLoads += 1;
    dispatch({ type: LOADER_START, payload: true });
};

export const loaderStop = () => dispatch => {
    pendingLoads = Math.max(0, pendingLoads - 1);
    if (pendingLoads === 0) {
        dispatch({ type: LOADER_STOP, payload: false });
    }
};

export const callLoader = (val) => dispatch => {
    if (val === 1 || val === true) {
        dispatch(loaderStart());
    } else {
        dispatch(loaderStop());
    }
};
